import React from 'react';
import Hero from '../components/Hero';
import WelcomeSection from '../components/WelcomeSection';
import RealGuides from '../components/RealGuides';
import WhyChooseUs from '../components/WhyChooseUs';
import OurServices from '../components/OurServices';
import HowItWorks from '../components/HowItWorks';
import BookYourSession from '../components/BookYourSession';
import NewsletterSignup from '../components/NewsletterSignup';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <WhyChooseUs />
      <RealGuides />
      <OurServices />
      <BookYourSession />
      <HowItWorks />
      <WelcomeSection />
      <NewsletterSignup />
    </div>
  );
};

export default Home;